import styled from '@emotion/styled';
import { H1, H2, H3 } from 'ds/components/typography';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ValueText = styled(H1.withComponent('div'))`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `}
`;

export const MobileValueText = styled(H2.withComponent('div'))`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `}
`;

export const DescriptionText = styled(H3.withComponent('div'))`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `}
`;
